export default "__VITE_ASSET__BZdPSVys__"